export default {
    methods: {
        clicked() {
           return this.$store.getters.getnavigation;
        }
    }
};